import { useState } from "react";
import { toast } from "sonner";
import { X, FileText, CheckCircle2 } from "lucide-react";
import { http, gtmPush } from "../../lib/api";
import { getTrackingPayload } from "../../lib/utm";

export default function CaseStudiesModal({ open, onClose }) {
  const [data, setData] = useState({ full_name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!data.full_name.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)) {
      toast.error("Ingresa nombre y correo válido.");
      return;
    }
    setLoading(true);
    try {
      const tracking = getTrackingPayload();
      await http.post("/leads/case-studies", { ...data, ...tracking });
      gtmPush("case_studies_request");
      setDone(true);
      toast.success("Te enviaremos los 5 casos por correo.");
    } catch {
      toast.error("No pudimos registrar tu solicitud. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[95] bg-eclipse/85 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="case-studies-modal"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md bg-eclipse-900 border border-accent/60 p-8 md:p-10"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/60 hover:text-accent"
          aria-label="Cerrar"
          data-testid="case-studies-close"
        >
          <X className="w-5 h-5" />
        </button>

        {!done ? (
          <>
            <div className="flex items-center gap-3 mb-4">
              <FileText className="w-5 h-5 text-accent" />
              <span className="kicker">Casos de éxito</span>
            </div>
            <h3 className="font-display font-black text-2xl md:text-3xl text-white tracking-tightest leading-tight">
              Recibe <span className="text-accent">5 casos reales</span> con m², materiales y resultados.
            </h3>
            <p className="mt-3 text-white/70 text-sm">
              Proyectos entregados en México. Te los enviamos hoy mismo a tu correo.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-3" noValidate>
              <input
                type="text"
                required
                placeholder="Tu nombre"
                value={data.full_name}
                onChange={(e) => setData({ ...data, full_name: e.target.value })}
                className="w-full bg-eclipse border border-white/15 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-accent"
                data-testid="case-studies-name"
              />
              <input
                type="email"
                required
                placeholder="tu@correo.com"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                className="w-full bg-eclipse border border-white/15 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-accent"
                data-testid="case-studies-email"
              />
              <button
                type="submit"
                disabled={loading}
                className="btn-accent w-full justify-center disabled:opacity-60"
                data-testid="case-studies-submit"
              >
                {loading ? "Enviando…" : "Recibir casos de éxito"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="case-studies-success">
            <CheckCircle2 className="w-12 h-12 text-accent mx-auto" />
            <h3 className="mt-4 font-display font-black text-2xl text-white">¡Gracias!</h3>
            <p className="mt-3 text-white/70 text-sm">
              En breve recibirás los 5 casos de éxito en <span className="text-accent">{data.email}</span>.
            </p>
            <button onClick={onClose} className="btn-accent mt-6">Cerrar</button>
          </div>
        )}
      </div>
    </div>
  );
}
